// Source glyph tile — color@~9% bg, color@40% border, the real SITE_ICON path(s)
// (Google uses the multicolor GoogleLogo). Extracted from SourcesSurface so the
// onboarding hub and the shared ConsentModal render identical source icons.

import { siteColor, SITE_ICON } from '../../lib/sites';
import { GoogleLogo } from './Icons';

export function SourceIcon({ id, size = 24 }: { id: string; size?: number }) {
  const color = siteColor(id);
  const icon = SITE_ICON[id];
  const iconColor = color === 'var(--text3)' ? 'var(--text2)' : color;
  // The Google mark is multi-color, so the brand-tinted tile + faint brand border
  // (which the single-color glyphs use) washes it out to white-on-white. Give it the
  // neutral logo tile + an ink border instead — legible in both themes, like the mock's .ltile.
  const isGoogle = id === 'google' || id === 'google-docs';
  return (
    <div style={{
      width: size, height: size, borderRadius: 6,
      background: isGoogle ? 'var(--logo-tile)' : color === 'var(--text3)' ? 'var(--bg3)' : `${color}18`,
      border: `1px solid ${isGoogle ? 'color-mix(in srgb, var(--ink) 12%, transparent)' : color === 'var(--text3)' ? 'var(--border)' : color + '40'}`,
      display: 'grid', placeItems: 'center',
      flexShrink: 0,
    }}>
      {isGoogle ? (
        <GoogleLogo size={size * 0.62} />
      ) : icon ? (
        <svg viewBox={icon.viewBox} fill={iconColor} width={size * 0.6} height={size * 0.6}>
          {icon.paths.map((p, i) => (
            <path key={i} d={p.d} fillRule={p.fillRule} />
          ))}
        </svg>
      ) : (
        <span style={{
          fontFamily: 'var(--mono)', fontSize: Math.max(8, size * 0.38),
          color: iconColor, textTransform: 'uppercase', letterSpacing: '0.04em', fontWeight: 600,
        }}>
          {(id || '??').slice(0, 2)}
        </span>
      )}
    </div>
  );
}
